"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _theme = require("./theme");

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Provider = function Provider(props) {
  return _react2.default.createElement(_styledComponents.ThemeProvider, { theme: _theme2.default, children: props.children });
};

exports.default = Provider;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-theme/dist/Provider.js
// module id = 454
// module chunks = 168707334958949